let bMessengerLoaded = false; /**WEBMESS-540: boolean variable to determine if the Messenger plugin is already initialized or not, when the Genesys.init command is getting called without page refresh*/

function initMessenger(config, GenesysJS) {
  const messenger = config.deploymentConfig.messenger||{};

  const $$ = GenesysJS.data;

  if (messenger.enabled === true) {
    if (!bMessengerLoaded) {
      bMessengerLoaded = true;
      GenesysJS.log('Messenger enabled. Loading MessengerHelper plugin.');

      GenesysJS.subscribe('MessengerHelper.ready', () => {
        GenesysJS.command('MessengerHelper.open', config.deploymentConfig);
      });
    } else { /**If Messenger is already initialized, look for the iFrame existence, if yes, configure messenger again with the config*/
      const iFrameLoaded = $$('MessengerHelper.iFrameLoaded');

      if (iFrameLoaded) {
        GenesysJS.command('MessengerHelper.update', config.deploymentConfig);
      } else GenesysJS.command('MessengerHelper.open', config.deploymentConfig);
    }
  }
}

export default initMessenger;
